var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"src-components-main"},[_c('router-view',{on:{"refresh-header":function($event){return _vm.refreshHeader()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }